import { render, staticRenderFns } from "./previewDia.vue?vue&type=template&id=470f593a&scoped=true&"
import script from "./previewDia.vue?vue&type=script&lang=js&"
export * from "./previewDia.vue?vue&type=script&lang=js&"
import style0 from "./previewDia.vue?vue&type=style&index=0&id=470f593a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470f593a",
  null
  
)

export default component.exports